var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.68616C17.7571 6.73009 17.5069 6.75302 17.2513 6.75302C14.9397 6.75302 13.0657 4.87688 13.0657 2.56255C13.0657 1.80185 13.2682 1.0885 13.6221 0.473551C13.2804 0.406958 12.9274 0.37207 12.5663 0.37207C9.53232 0.37207 7.0728 2.8345 7.0728 5.87207C7.0728 8.90964 9.53232 11.3721 12.5663 11.3721C15.324 11.3721 17.6071 9.33769 18 6.68616Z",
    fill: "#6587FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00373 13.6188C0.880346 13.5175 0 12.5723 0 11.4212C0 10.2025 0.986769 9.21459 2.20401 9.21459C2.2733 9.21459 2.34184 9.21779 2.4095 9.22406C2.40607 9.15428 2.40433 9.08405 2.40433 9.01342C2.40433 6.68684 4.28816 4.80078 6.61198 4.80078C8.60722 4.80078 10.2781 6.19118 10.7107 8.05701C10.876 8.02662 11.0464 8.01074 11.2205 8.01074C12.7697 8.01074 14.0256 9.26812 14.0256 10.8192C14.0256 12.3702 12.7697 13.6276 11.2205 13.6276C11.1978 13.6276 11.1751 13.6273 11.1526 13.6268H2.27256C2.2498 13.6275 2.22694 13.6278 2.20401 13.6278C2.18107 13.6278 2.15822 13.6275 2.13545 13.6268H2.00373V13.6188Z",
    fill: "#C4E1E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09935 5.63406C4.2663 5.61389 4.43625 5.60352 4.60863 5.60352C6.60385 5.60352 8.27472 6.99389 8.70736 8.8597C8.8726 8.82934 9.0429 8.81348 9.2169 8.81348C10.7661 8.81348 12.022 10.0709 12.022 11.6219C12.022 12.4074 11.6999 13.1176 11.1807 13.6273C11.1939 13.6275 11.2072 13.6276 11.2205 13.6276C12.7697 13.6276 14.0256 12.3702 14.0256 10.8192C14.0256 9.26812 12.7697 8.01074 11.2205 8.01074C11.0464 8.01074 10.8761 8.02662 10.7108 8.05701C10.2781 6.19118 8.60725 4.80078 6.61201 4.80078C5.67013 4.80078 4.80053 5.11062 4.09935 5.63406Z",
    fill: "#A4D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/evening.c56ef6bb731c436760551532a211d159.svg";
export { ForwardRef as ReactComponent };